import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap';
import { useForm} from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";

// components

// labels

// services & providers

// actions
import {udnService} from "../../../../jwt/_services";
import {getStateByPath} from "../../../../redux/selectors";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {GenericButton} from "../../../../components/buttons/customButtons";
import Separator from "../../../../components/Separator";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {placeService} from "../../../../jwt/_services/hotel/placeService";
import {INTERNATIONAL, REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import { setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";
import HomeUdnLangs from "./_langs";

const HomeUdnForm = ( props ) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject } = componentState?.data;

    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [buyStatus, setBuyStatus] = useState( domainObject?.buyStatus !== undefined ? domainObject?.buyStatus : false);
    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            name: domainObject?.name,
            showOrder: domainObject?.showOrder,
            logo: domainObject?.logo,
            image: domainObject?.image,
            code: domainObject?.code,
            color: domainObject?.color,
            photoCode: domainObject?.photoCode,
            albumPhoto: domainObject?.albumPhoto,
            productName: domainObject?.productName,
            sivexCode: domainObject?.sivexCode,
            status: domainObject?.status,
            home: domainObject?.home,
            buyStatus: domainObject?.buyStatus,
            xapiId: domainObject?.xapiId,
            componentId : domainObject?.componentId,
            colorDark: domainObject?.colorDark,
            idSynxis: domainObject?.idSynxis,
            minAgeChildren: domainObject?.minAgeChildren,
            paxDefault: domainObject?.paxDefault,
            paxRules: domainObject?.paxRules,
            tags: domainObject?.tags,
            maxNights: domainObject?.maxNights,
            minNights: domainObject?.minNights,
            iconXkynet: domainObject?.iconXkynet,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                id : domainObject?.id,

                status : status,
                buyStatus : buyStatus,

                langs: langs,
            }
        };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, udnService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, udnService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setForm(path, );
        props.onClose()
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: placeService
        } );
    };
    

    return (<>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Card className={'card-modal-medium'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { app.name + '  / UDN / ' + udn.value  }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    {/*<Separator/>*/}
                                    <GenericButton
                                        style={'table'}
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                    <TranslateButton item={domainObject} service={placeService} />
                                    {/*<GenericButton*/}
                                    {/*    style={'danger-secondary'}*/}
                                    {/*    toolTip={TT_DELETE}*/}
                                    {/*    icon={'fa-trash'}*/}
                                    {/*    permission={'delete'}*/}
                                    {/*    onClick={_ => confirmDelete(domainObject)}*/}
                                    {/*/>*/}
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="3">
                                <FormGroup>
                                    <Label>{'Codigo'}</Label>
                                    <Input type="text"
                                           name="code"
                                           id="code"
                                           disabled={true}
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="logo">Logo</Label>
                                    <Input type="name" name="logo" id="logo"
                                           placeholder="Logo"
                                           innerRef={register}

                                    />
                                </FormGroup>
                            </Col>

                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="idSynxis">Código Synxis </Label>
                                    <Input type="text" name="idSynxis" id="idSynxis"
                                           placeholder="Código sistema Synxis"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="color">Color</Label>
                                    <div className="form-control-color-input">
                                        <Input type="color" name="color" id="color"
                                               innerRef={register}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="minAgeChildren">Edad minima</Label>
                                    <Input type="number" name="minAgeChildren" id="minAgeChildren"
                                           placeholder="13"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Minimo de noches</Label>
                                    <Input type="number" name="minNights" id="minNights"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Maximo de noches</Label>
                                    <Input type="number" name="maxNights" id="maxNights"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="colorDark">Color Obscuro </Label>
                                    <div className="form-control-color-input">
                                        <Input type="color" name="colorDark" id="colorDark"
                                               innerRef={register}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="paxDefault">Pax default </Label>
                                    <Input type="text" name="paxDefault" id="paxDefault"
                                           placeholder="2/0 : Adulto/Menor"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label htmlFor="paxRules">Reglas de pax </Label>
                                    <Input type="text" name="paxRules" id="paxRules"
                                           placeholder="Adulto/Menor|Adulto/Menor"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label htmlFor="showOrder">Orden</Label>
                                    <Input type="number" name="showOrder" id="showOrder"
                                           placeholder="Orden"
                                           innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label htmlFor="status">Activo</Label><br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            innerRef={register}
                                            onChange={_ => setStatus(!status)}
                                            value={status}/>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label htmlFor="but">Habilitar Compra</Label><br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            innerRef={register}
                                            onChange={_ => setBuyStatus(!buyStatus)}
                                            value={buyStatus}/>
                                </FormGroup>
                            </Col>

                        </Row>
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{INTERNATIONAL}</h2>
                            </div>
                            <div className={''}>
                                <Row>
                                    <HomeUdnLangs
                                        langs={langs}
                                        setLangs={setLangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </Row>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Form>
            {
                showHistoryModal && <LogHistoryModal
                    ref={modalHistoryRef}
                    item={domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(HomeUdnForm)
